import { render, staticRenderFns } from "./AccountTypeSubheader.vue?vue&type=template&id=1295a2a9&scoped=true"
import script from "./AccountTypeSubheader.vue?vue&type=script&lang=ts"
export * from "./AccountTypeSubheader.vue?vue&type=script&lang=ts"
import style0 from "./AccountTypeSubheader.vue?vue&type=style&index=0&id=1295a2a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295a2a9",
  null
  
)

export default component.exports